import styled from 'styled-components';

export const Container = styled.div`
  input[disabled],
  textarea[disabled] {
      background-color: #dadada;
      cursor: not-allowed;
  }
  textarea {
    margin-bottom: 10px;
    display: block;
  }
  .upload-group {
    .label {
      font-weight: bold;
      display: block;
      margin-top: 7px;
    }
    .secondary-label {
      font-weight: bold;
      color: #aaa;
      display: block;
    }
    .desc {
      font-style: italic;
      font-size: 12px;
      color: #a0a0a0;
      display: block;
      margin-bottom: 10px;
    }
    input[type='file'] {
      margin-bottom: 15px;
    }
    .ReactCrop__current-cover {
      width: 100%;
    }
  }

  @media (max-width: 576px) {
    select[name=segment] {
      margin-bottom: 10px;
    }
  }
`;

export const ButtonPanel = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 15px;

  .btn {
    margin-left: 10px;
  }
`;



// WEBPACK FOOTER //
// ./src/pages/EditEvent/styles.js